import { createApp } from 'vue';
import { createPinia } from 'pinia';
import cmpVendorIDs from '../../globals/constants/cmpVendorIDs';
import ConsentModalHost from './ConsentModalHost.vue';

export default function initConsentModals(pinia) {
  const modalPinia = pinia || createPinia();

  Object.entries(cmpVendorIDs).forEach(([vendorKey, vendor]) => {
    if (!vendor.triggerSelector) {
      return;
    }

    const rootId = `consent-modal-${vendorKey.toLowerCase()}`;
    if (document.getElementById(rootId)) {
      return;
    }

    const root = document.createElement('div');
    root.id = rootId;
    document.body.append(root);

    createApp(ConsentModalHost, {
      vendorKey,
      vendorId: vendor.id,
      triggerSelector: vendor.triggerSelector,
    })
      .use(modalPinia)
      .mount(root);
  });
}
